// extracted by css-extract-rspack-plugin
export default {"root":"NotificationTitle_root__6xcgA"};